import { Role } from './role';

export class User {
  id: string;
  name: string;
  email: string;
  url: string;
  roles: string[] = [];
  date: Date;
  disabled: boolean;
  token: string;

  constructor(id: string, name: string, email: string, url: string, roles: string[], date: Date, disabled: boolean) {
    this.id = id;
    this.name = name;
    this.email = email;
    this.url = url;
    this.roles = roles;
    this.date = date;
    this.disabled = disabled;
  }

  hasRole(id) {
    return this.roles.indexOf(id) != -1;
  }

}



// WEBPACK FOOTER //
// ./src/app/users/models/user.ts